var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4034 1.01H9.40335V3.01H15.4034V1.01ZM11.4034 14.01H13.4034V8.01H11.4034V14.01ZM19.4334 7.39L20.8534 5.97C20.4234 5.46 19.9534 4.98 19.4434 4.56L18.0234 5.98C16.4734 4.74 14.5234 4 12.4034 4C7.43335 4 3.40335 8.03 3.40335 13C3.40335 17.97 7.42335 22 12.4034 22C17.3834 22 21.4034 17.97 21.4034 13C21.4034 10.89 20.6634 8.94 19.4334 7.39ZM12.4034 20.01C8.53335 20.01 5.40335 16.88 5.40335 13.01C5.40335 9.14 8.53335 6.01 12.4034 6.01C16.2734 6.01 19.4034 9.14 19.4034 13.01C19.4034 16.88 16.2734 20.01 12.4034 20.01Z",
    fill: "#5D5FEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.333344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/Timer.41e72d4713497e49726181b26d362af2.svg";
export { ForwardRef as ReactComponent };